module.exports = __webpack_public_path__ + "img/banner-pumpkin-mobile.1c8da6b5.png";